export default __webpack_public_path__ + "static/media/Intimation-of-Earnings-Call-Q1FY27.1f0f33ba.pdf";